import React, { Component } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import { getOutletStocks } from "../../../../../services/sales/outletService";
import { formatDate } from "../../../../../utils/utils";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import withGlobalData from "../../../common/withGlobalData";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
class OutletStocks extends Component {
  state = {
    reload: this.props.globalData.reload,
    auth: {},
    open: false,
    stocks: [],
  };

  componentDidMount() {
    this.getOutletStocksData();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getOutletStocksData();
      this.setState({ reload: globalData.reload });
    }
  }

  async getOutletStocksData() {
    const {
      outletID: outletIDprop = 0,
      itemID = 0,
      varCode = "",
      match,
    } = this.props;
    let outletID = 0;
    if (outletIDprop > 0) {
      outletID = outletIDprop;
    } else {
      const { outletID: outletIDparam = 0 } = match.params;
      outletID = parseInt(outletIDparam);
    }
    if (outletID > 0) {
      const response = await getOutletStocks(outletID, itemID, varCode);
      const { data, auth } = response.data;
      const { outletStocks } = data;
      this.setState({ stocks: outletStocks, auth });
    }
  }

  render() {
    const { stocks } = this.state;
    return (
      <React.Fragment>
        {stocks.length ? (
          <React.Fragment>
            <CustomDataTable
              data={stocks}
              onRefreshData={() => {
                this.getOutletStocksData();
              }}
              columns={[
                {
                  header: "Item Type",
                  field: "itemTypeName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.itemTypeName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Item Code",
                  field: "itemCode",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.itemType > 0 ? (
                        <span>
                          <BootstrapTooltip title={rowData.itemTypeName}>
                            <span className="mr-2">
                              <i
                                className={
                                  rowData.itemType === 1
                                    ? "fas fa-boxes text-success"
                                    : rowData.itemType === 2
                                    ? "fas fa-tools text-primary"
                                    : rowData.itemType === 3
                                    ? "fas fa-building text-info"
                                    : rowData.itemType === 4
                                    ? "fas fa-boxes text-warning"
                                    : rowData.itemType === 5
                                    ? "fas fa-boxes text-danger"
                                    : null
                                }
                              ></i>
                            </span>
                          </BootstrapTooltip>
                          <span>
                            <ResponsiveEllipsis
                              text={rowData.itemCode}
                              maxLine="1"
                              displayInline
                            />
                          </span>
                        </span>
                      ) : (
                        <React.Fragment>
                          <ResponsiveEllipsis
                            text={rowData.itemCode}
                            maxLine="1"
                          />
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Item Name",
                  field: "itemName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Quantity",
                  field: "qty",
                  body: (rowData) => (
                    <div>
                      {rowData.qty} {rowData.uomName}
                    </div>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Unit",
                  field: "uomName",
                  body: null,
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Batch ID",
                  field: "batchID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Production Date",
                  field: "productionDate",
                  body: (rowData) => formatDate(rowData.productionDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Expiry Date",
                  field: "expiryDate",
                  body: (rowData) => formatDate(rowData.expiryDate),
                  sortable: true,
                  filter: true,
                },
              ]}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Illustration
              imageSource="INVIFO Inventory.png"
              description="Hooray! You're ready to have your first Stock for this outlet!"
              guidance="Hint: request some items from warehouses and receive the goods, or perform manual stock entries via stock movement"
              descriptionLeftIcon="fas fa-info-circle kt-font-success"
              size="md"
            ></Illustration>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default withGlobalData(OutletStocks);
